import React, { useEffect } from "react";
import { SpinnerCircular } from "spinners-react";
import { useTheme } from "styled-components";
import { Body } from "../../styles/typography";
import { getCurrentUser } from "@aws-amplify/auth";
import { useNavigate } from "react-router-dom";

const AuthCallBack = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentUser()
      .then((user) => {
        console.log("user in callback ", user);
        if (user.userId) {
          navigate("/edit-submission", { replace: true });
        }
      })
      .catch((err) => {
        console.log("Fetch user error", err);
        navigate("/user");
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "16px",
        padding: "0 24px",
      }}
    >
      <SpinnerCircular
        size={48}
        thickness={200}
        aria-label="Loading Spinner"
        speed={100}
        color={`rgba(${theme.colors.neutral200}, 1)`}
        secondaryColor={`rgba(${theme.colors.neutral100}, 1)`}
        style={{
          justifySelf: "center",
        }}
      />
      <Body style={{ textAlign: "center" }}>
        Please wait while we sign you in.
      </Body>
    </div>
  );
};

export default AuthCallBack;
